import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import FirebaseApp from './FirebaseApp';

ReactDOM.render(
  <React.StrictMode>
    <FirebaseApp />
  </React.StrictMode>,
  document.getElementById('root')
);
